/** @jsxImportSource @emotion/react */
import { useContext, useEffect, useState } from "react";
import * as React from "react";
import moment from "moment";
import AppBar from "../../components/AppBar";
import { baseUrl } from "../../connections";

import { useGetProfileScreenStyles } from "./index.styles";
import { useLogout } from "../../hooks/services/uselogout";
import TextBox from "../../components/TextBox";
import Snackbar from "../../components/Snackbar";
import uuid from "react-uuid";
import Button from "../../components/Button";
import BackButton from "../../components/BackButton";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Avatar from "../../components/Avatar";
import { useGetNavItems } from "../Home/appbarNav";
import { ssnFormat, zipFormat, getBase64, IdProofFormat } from "../../utils";
import { useStateData } from "../../hooks/services/useStateData";
import { useCountyData } from "../../hooks/services/useCountyData";
import DeleteIcon from "@mui/icons-material/Delete";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// import setAccountDeletePayloads
// import {setAccountDeletePayloads} from "../../hooks/services/useAccountDelete"
import { useAccountDelete } from "../../hooks/services/useAccountDelete";
import { useCityData } from "../../hooks/services/useCityData";
import { COUNTRY } from "../../constants";
// import AppFooter from "../../components/AppFooter";
import Footer1 from "../../components/Footer/Footer";
import axios from "axios";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Delete } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useGetBackButtonStyles } from "../../components/BackButton/index.styles";

const Profile = () => {
  const size = 88;
  const styles = useGetBackButtonStyles({ size });
  const classes = useGetProfileScreenStyles();
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const { setPayloadsLogout } = useLogout();
  const [isDisabled, setIsDisabled] = useState(true);
  const [selCountry, setSelCountry] = useState();
  const [selState, setSelState] = useState();
  const [selCounty, setSelCounty] = useState();
  const [selCity, setSelCity] = useState();
  const { stateData, setStateData } = useStateData();
  const { countyData, setCountyData } = useCountyData();
  const { cityData, setCityData } = useCityData();
  const [errortoast, seterrortoast] = useState(false);
  const [success, setsuccess] = useState(false);
  // const { setAccountDeletePayloads } = useAccountDelete();
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    setStateData(userDetails?.address?.country);
    setCountyData(userDetails?.address?.state);
    setCityData(userDetails?.address?.county);
  }, [userDetails]);

  useEffect(() => {
    if (userDetails) {
      const country = COUNTRY.find(
        (val) => userDetails?.address?.country == val.value,
      );
      setSelCountry(country?.key);
    }
  }, [userDetails]);

  useEffect(() => {
    if (stateData) {
      const state = stateData.find(
        (val) => userDetails?.address?.state === val.uuid,
      );
      setSelState(state?.name);
    }
  }, [stateData]);

  useEffect(() => {
    if (countyData) {
      const county = countyData.find(
        (val) => userDetails?.address?.county === val.uuid,
      );
      setSelCounty(county?.name);
    }
  }, [countyData]);

  useEffect(() => {
    if (cityData) {
      const city = cityData.find(
        (val) => userDetails?.address?.city === val.uuid,
      );
      setSelCity(city?.name);
    }
  }, [cityData]);
  const [interests, setinterests] = useState([]);
  // const [open ,setopen ] = useState(false)

  // const HandleDelete = (uuid) => {
  //   console.log(uuid, "uuiduuid545344")
  //   // setAccountDeletePayloads(uuid)
  //   // alert('hsff45645')
  //   // setAccountDeletePayloads(uuid)

  // }
  const handlelogout = () => {
    setPayloadsLogout({
      user_uuid: userDetails?.user_uuid,
    });
    setTimeout(() => {
      navigate("/login");
      // logoutHandler()
    }, 1000);
  };
  function MyComponent() {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    return <Dialog fullScreen={fullScreen} />;
  }

  const HandleDelete = (id) => {
    axios
      .delete(`${baseUrl}/user/delete/account/${userDetails?.user_uuid}`, {
        headers: {
          "x-auth-token": userDetails?.token,
        },
      })
      .then((res) => {
        setTimeout(() => {
          handleClose();
          handlelogout();
        }, 1000);
        setsuccess(true);
      })
      .catch((err) => {
        seterrortoast(true);
        // <Snackbar/>
        // toast.error(err.response.data)
      });
  };

  //   useEffect(() => {
  //     if (userDetails?.intrests) {
  //         const optionslanguage = luserDetails?.intrests?.map((item) => ({
  //             value: item,
  //             label: item
  //         }));
  //         setinterests(optionslanguage);
  //     }

  // }, [userDetails]);

  const backhandle = () => {
    navigate("/home");
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "8px",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "20px", fontWeight: 600 }}
        >
          Are you sure you want to delete this account?
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ color: "#718096" }}
          >
            This action cannot be undone. All your data will be permanently
            deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button onClick={handleClose} variant="outlined">
            No, Cancel
          </Button>
          <Button onClick={HandleDelete} variant="contained" color="error">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <AppBar navItems={useGetNavItems({}).navItems} pageTitle="My Account" />
        <div>
          <div css={classes.signUpFormContainer}>
            <div css={classes.signupForm}>
              {/* Avatar Section */}
              <div css={classes.avatarSection}>
                <div css={classes.avatarWrapper}>
                  <Avatar
                    src={userDetails.avatar}
                    flatStyle
                    rounded
                    size={120}
                  />
                </div>
                <div css={classes.userInfoPill}>
                  <span css={classes.userName}>
                    {userDetails?.firstName} {userDetails?.lastName}
                  </span>
                  <span css={classes.userEmail}>
                    {userDetails?.primaryEmail}
                  </span>
                </div>
              </div>

              <div css={classes.formFieldsWrapper}>
                {/* Personal Information Card */}
                <div css={classes.sectionCard}>
                  <div css={classes.sectionTitle}>Personal Information</div>
                  <div css={classes.formFieldsGroup}>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        label="First Name"
                        variant="outlined"
                        fullWidth
                        disabled={isDisabled}
                        value={userDetails?.firstName || ""}
                        id="firstName"
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="Last Name"
                        fullWidth
                        disabled={isDisabled}
                        value={userDetails?.lastName || ""}
                        id="lastName"
                        css={classes.textField}
                      />
                    </div>
                    <div css={classes.formFieldsFlexGroup}>
                      {userDetails?.phone?.code && (
                        <TextField
                          variant="outlined"
                          label="Phone"
                          type="tel"
                          fullWidth
                          disabled={isDisabled}
                          value={`${userDetails?.phone?.code} ${userDetails?.phone?.value}`}
                          id="phone"
                          css={classes.textField}
                        />
                      )}
                      <TextField
                        variant="outlined"
                        label="Primary Email"
                        type="email"
                        value={userDetails?.primaryEmail || ""}
                        fullWidth
                        disabled={isDisabled}
                        id="primaryEmail"
                        css={classes.textField}
                      />
                    </div>
                  </div>
                </div>

                {/* Address Information Card */}
                <div css={classes.sectionCard}>
                  <div css={classes.sectionTitle}>Address Information</div>
                  <div css={classes.formFieldsGroup}>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        variant="outlined"
                        label="Address Line 1"
                        fullWidth
                        disabled={isDisabled}
                        value={userDetails?.address?.location || ""}
                        id="location"
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="Address Line 2"
                        fullWidth
                        disabled={isDisabled}
                        value={userDetails?.address?.addressLine1 || ""}
                        id="addressLine1"
                        css={classes.textField}
                      />
                    </div>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        variant="outlined"
                        label="Country"
                        fullWidth
                        disabled={isDisabled}
                        value={
                          selCountry || userDetails?.address?.country || ""
                        }
                        id="country"
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="State"
                        fullWidth
                        disabled={isDisabled}
                        id="state"
                        value={selState || userDetails?.address?.state || ""}
                        css={classes.textField}
                      />
                    </div>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        variant="outlined"
                        label="County"
                        fullWidth
                        disabled={isDisabled}
                        value={selCounty || userDetails?.address?.county || ""}
                        id="county"
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="City"
                        fullWidth
                        disabled={isDisabled}
                        id="city"
                        value={selCity || userDetails?.address?.city || ""}
                        css={classes.textField}
                      />
                    </div>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        variant="outlined"
                        label="House No"
                        fullWidth
                        disabled={isDisabled}
                        value={userDetails?.address?.apartmentNo || ""}
                        id="apartmentNo"
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="ZIP Code"
                        fullWidth
                        disabled={isDisabled}
                        type="text"
                        value={userDetails?.address?.zip || ""}
                        id="zip"
                        css={classes.textField}
                      />
                    </div>
                    <TextField
                      variant="outlined"
                      label="Landmark/Housing Community"
                      fullWidth
                      disabled={isDisabled}
                      value={userDetails?.address?.landmark || ""}
                      id="landmark"
                      css={classes.textField}
                    />
                  </div>
                </div>

                {/* Demographics Card */}
                <div css={classes.sectionCard}>
                  <div css={classes.sectionTitle}>Demographics</div>
                  <div css={classes.formFieldsGroup}>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        variant="outlined"
                        label="Race/Ethnicity"
                        fullWidth
                        disabled={isDisabled}
                        value={userDetails?.demographics?.race || ""}
                        id="race"
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="Date of Birth"
                        fullWidth
                        disabled={isDisabled}
                        type="date"
                        value={
                          userDetails?.demographics?.dob
                            ? moment(userDetails?.demographics?.dob).format(
                                "YYYY-MM-DD",
                              )
                            : ""
                        }
                        id="dob"
                        InputLabelProps={{ shrink: true }}
                        css={classes.textField}
                      />
                    </div>
                    <TextField
                      variant="outlined"
                      label="Religion"
                      fullWidth
                      disabled={isDisabled}
                      value={userDetails?.religion || ""}
                      id="religion"
                      css={classes.textField}
                    />
                  </div>
                </div>

                {/* Preferences Card */}
                <div css={classes.sectionCard}>
                  <div css={classes.sectionTitle}>Preferences</div>
                  <div css={classes.formFieldsGroup}>
                    <div css={classes.formFieldsFlexGroup}>
                      <TextField
                        variant="outlined"
                        label="Interests"
                        fullWidth
                        disabled={isDisabled}
                        value={
                          userDetails?.intrests
                            ? userDetails.intrests.join(", ")
                            : ""
                        }
                        id="interests"
                        multiline
                        rows={2}
                        css={classes.textField}
                      />
                      <TextField
                        variant="outlined"
                        label="Languages"
                        fullWidth
                        disabled={isDisabled}
                        value={
                          userDetails?.languages
                            ? userDetails.languages.join(", ")
                            : ""
                        }
                        id="languages"
                        multiline
                        rows={2}
                        css={classes.textField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <AppFooter /> */}
        <Footer1 />
      </div>
      {/* {errortoast === true &&
        <Snackbar key={uuid()} message="Something went Wrong!" isOpen={errortoast} />
      }
      {success === true &&
        <Snackbar key={uuid()} message={"Account deleted successfully!"} isOpen={success} severity={'success'} />
      } */}
      {/* errortoast */}
    </>
  );
};

export default Profile;
